/* eslint-disable camelcase */
import { VIDEO_TYPE, AUDIO_TYPE, FILE_UPLOAD_TYPE, } from 'wix-rich-content-common';
import { resolveFileUrl } from '@wix/ricos-media';
export const getVideoUrl = (src) => `https://video.wixstatic.com/${src.pathname}`;
export const getThumbnailUrl = (src) => {
    if (src.pathname.startsWith('media/')) {
        return `https://static.wixstatic.com/${src.pathname}`;
    }
    return `https://static.wixstatic.com/media/${src.pathname}`;
};
export const getAudioUrl = (src) => `https://static.wixstatic.com/${src.id}`;
export default function urlResolutionStrategy(hasPlugin, instance, metaSiteId, _experiments // eslint-disable-line
) {
    if (!metaSiteId) {
        return { config: {} };
    }
    return {
        config: {
            ...(hasPlugin(VIDEO_TYPE) && {
                [VIDEO_TYPE]: {
                    getVideoUrl,
                    getThumbnailUrl,
                },
            }),
            ...(hasPlugin(AUDIO_TYPE) && {
                [AUDIO_TYPE]: {
                    getAudioUrl,
                },
            }),
            ...(hasPlugin(FILE_UPLOAD_TYPE) &&
                metaSiteId && {
                [FILE_UPLOAD_TYPE]: {
                    resolveFileUrl: resolveFileUrl(metaSiteId, instance),
                },
            }),
        },
        helpers: {
            getImageUrl({ file_name }) {
                return `https://static.wixstatic.com/media/${file_name}`;
            },
        },
    };
}
//# sourceMappingURL=urlResolutionStrategy.js.map